module.exports = __webpack_public_path__ + "static/img/appointment03.9579e8fc.png";